import React, { Component } from 'react';
import { Button, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import Testimonial from '../copmpnents/Testimonial/Testimonial.js';

import { forgotPassword } from '../AuthActions';

import logo from './img/logo-nave-icon.svg';

// Import Style
import '../Auth.scss';

class ForgotPass extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
    };
  }

  handleChange = (ev) => {
    this.setState({
      [ev.target.name]: ev.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.forgotPassword({
      email: this.state.email,
    });
  };

  render() {
    return (
      <div className='login_bg'>
        <div className='login_form'>
          <div className='logo'>
            <img src={logo} alt="" />
          </div>
          <div className='login_content'>
            {!this.props.rpSent ? (
              <div className='left_part'>
                <h1>Forgot your password?</h1>
                <p className="mb-4">
                  Enter your email here and we'll send a link to reset it. If you are still having trouble, <br />
                  <a href="mailto:hello@getnave.com">get in touch</a> with us and we'll take care of it.
                </p>
                <Form className='form' noValidate onSubmit={this.handleSubmit}>
                  <Form.Label htmlFor="email">Email</Form.Label>
                  <Form.Group>
                    <Form.Control
                      autoFocus
                      placeholder="Email"
                      type="email"
                      name="email"
                      id="email"
                      value={this.state.email}
                      onChange={this.handleChange}
                    />
                  </Form.Group>

                  <Button type="submit" className="mt-4" variant="primary">
                    Submit
                  </Button>
                  <Link className="link-back mt-4" to="/login">
                    Back
                  </Link>
                </Form>
              </div>
            ) : (
              <div className='left_part'>
                <Form className='form'>
                  <h1>Partner Portal</h1>
                  <p className="mb-4">Thank you! We sent you an email with instructions on how to reset your password</p>

                  <Link className="link-back mt-4" to="/login">
                    Back to Login
                  </Link>
                </Form>
              </div>
            )}
            <div className='right_part'>
              <Testimonial />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    forgotPassword: (body) => dispatch(forgotPassword(body)),
  };
};

function mapStateToProps(state) {
  return {
    rpSent: state.auth.rpSent,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ForgotPass));
